import { render, staticRenderFns } from "./good-banner.vue?vue&type=template&id=549d0136&scoped=true&"
import script from "./good-banner.vue?vue&type=script&lang=js&"
export * from "./good-banner.vue?vue&type=script&lang=js&"
import style0 from "./good-banner.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./good-banner.vue?vue&type=style&index=1&id=549d0136&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549d0136",
  null
  
)

export default component.exports